import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonMan = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17 31L19 26H21L23 31",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.003 14.796C14.633 14.982 15.295 15.106 15.985 15.106C17.945 15.106 19.714 14.298 20.985 13C22.256 14.298 24.039 15.106 25.999 15.106",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 15C14 11.686 16.686 9 20 9C23.314 9 26 11.686 26 15C26 20 23.314 23 20 23C16.686 23 14 20 14 15Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.796 21.907L10.971 25.417C10.369 25.779 10 26.43 10 27.132V31H30V27.132C30 26.429 29.631 25.778 29.029 25.417L23.204 21.907",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgPersonMan);
export default ForwardRef;
